import { handleActions } from "redux-actions";

import {
	getLinksListAsyncAction,
	postLinksManyAsyncAction,
	truncateLinksAsyncAction,
} from "./youtubeActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	links_list: defaultAjaxState,
	post_links_many: defaultAjaxState,
	truncate_links: defaultAjaxState,
};

export const youtubeReducer = handleActions(
	new Map([
		// get links list
		[
			getLinksListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				links_list: {
					...initialState.links_list,
					loading: true,
				},
			}),
		],
		[
			getLinksListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				links_list: {
					...initialState.links_list,
					response: payload,
				},
			}),
		],
		[
			getLinksListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				links_list: {
					...initialState.links_list,
					error: payload,
				},
			}),
		],

		// post links many
		[
			postLinksManyAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_links_many: {
					...initialState.post_links_many,
					loading: true,
				},
			}),
		],
		[
			postLinksManyAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_links_many: {
					...initialState.post_links_many,
					response: payload,
				},
			}),
		],
		[
			postLinksManyAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_links_many: {
					...initialState.post_links_many,
					error: payload,
				},
			}),
		],

		// truncate links
		[
			truncateLinksAsyncAction.request,
			(state, { payload }) => ({
				...state,
				truncate_links: {
					...initialState.truncate_links,
					loading: true,
				},
			}),
		],
		[
			truncateLinksAsyncAction.success,
			(state, { payload }) => ({
				...state,
				truncate_links: {
					...initialState.truncate_links,
					response: payload,
				},
			}),
		],
		[
			truncateLinksAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				truncate_links: {
					...initialState.truncate_links,
					error: payload,
				},
			}),
		],
	]),
	initialState
);
